import PortfolioDetailCollapsible from './PortfolioDetailCollapsible'


export default PortfolioDetailCollapsible
